module.exports = __webpack_public_path__ + "avatar1.svg?b04d6c72cb07eac54b71db6fe0b456c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar1.svg
// module id = 137
// module chunks = 2